snt-wysiwyg {

    h1{
        margin-bottom: 40px;
    }

    h2{
        margin-top: 40px;
        margin-bottom: 15px;
    }

    h3, h4{
        margin-top: 20px;
        margin-bottom: 10px;
    }

    ul li{
        margin-top: 23px;
        margin-bottom: 23px;
    }

    @media (min-width: map-get($grid-breakpoints, md)) {
        h2{
            margin-bottom: 20px;
        }
    }

    @media (min-width: map-get($grid-breakpoints, lg)) {
        h1{
            margin-bottom: 60px;
        }

        h2{
            margin-top: 60px;
            margin-bottom: 25px;
        }

        h3, h4{
            margin-top: 30px;
            margin-bottom: 15px;
        }

        ul li{
            margin-top: 26px;
            margin-bottom: 26px;
        }
    }

    @media (min-width: map-get($grid-breakpoints, xl)) {

        h2{
            margin-bottom: 30px;
        }
    }

    .blog-icon-item {
        display: none;
        @media (min-width: map-get($grid-breakpoints, md)) {
            display: inline-block;
            vertical-align: middle;
            width: 30px;
            height: 30px;
            padding: 12px;
        }

        @media (min-width: map-get($grid-breakpoints, xl)) {
            width: 45px;
            height: 45px;
            padding: 15px;
        }
    }

    .photo-credit {
        font-size: 12px;
        display: flex;
        margin-top: -22px;
    }

    blockquote.bio-blurb {
      line-height: 1.2;
      max-width: 85rem;
      margin-top: 2rem;
      padding: 10px 20px;
      margin: 0 0 20px;
      border-left: 5px solid #acdde4;

        &>p {
          font-size: 14px;
          line-height: 1.5;
          @media (min-width: map-get($grid-breakpoints, lg)) {
            font-size: 16px;
          }
        }

      &>p::before, &>p::after {
        content: '';
      }
    }

    .blog-icon-container {
        border: 2px solid $color-secondary-medium;
        border-radius: 150px;
        align-items: center;
        justify-content: center;
        display: flex;
        @media (min-width: map-get($grid-breakpoints, md)) {
            width: 60px;
            height: 60px;
        }
        @media (min-width: map-get($grid-breakpoints, lg)) {
            width: 80px;
            height: 80px;
        }
    }

    .blog-logo-item {
        display: block;
        padding: 40px 0 40px 0;
        @media (min-width: map-get($grid-breakpoints, lg)) {
            padding: 60px 0 60px 0;
        }
    }

    blockquote {
        position: relative;
        margin: 0 12px;
        > p {
          font-family: "Averta-RegularItalic", Arial, Helvetica, sans-serif;
          font-style: italic;
          font-size: 1rem;
          line-height: 1.75rem; // 28px;
          @media screen and (min-width: map-get($grid-breakpoints, md)) {
            font-size: 1.1875rem; // 19px;
            line-height: 1.875rem; // 30px;
          }
          @media screen and (min-width: map-get($grid-breakpoints, lg)) {
            font-size: 1.3125rem; // 21px;
            line-height: 1.96875rem; //31.5px;
          }
          @media screen and (min-width: map-get($grid-breakpoints, xl)) {
            font-size: 1.75rem; // 28px;
            line-height: 2.8125rem; // 45px;
          }
        }
        > p::before,
        > p::after {
          position: absolute;
          display: inline-block;
          color: $color-primary-accent;
          font-family: "Averta-Bold", Arial, Helvetica, sans-serif;
          line-height: 90%;
        }
        > p::before {
          right: calc(100% + 0.25rem);
          content: open-quote;
        }
        > p::after
        {
          content: close-quote;
        }
    }

    .sub-header {
      display: flex;
      align-items: center;

      p {
        margin-bottom: 0 !important;
        float: left !important;
      }

      h2 {
        margin: 0 0 0 0;

        @media screen and (min-width: map-get($grid-breakpoints, md)) {
          margin: 0 0 0 15px;
        }
      }
    }

  .blue-circle {
    display: none;
    width: max-content;
    border-radius: 50%;
    border: 3px solid #acdde4;
    margin-left: 0;

    @media screen and (min-width: map-get($grid-breakpoints, md)) {
      display: block;
    }

  }

  .no-bullet {
    list-style: none;
  }

  .bio-blurb {
      max-width: 85rem;
      margin-top: 2rem;
      padding: 10px 20px; 
      margin: 0 0 20px; 
      border-left: 5px solid #acdde4;
  }

  .bio-blurb a[target=_blank] {
      margin-right: 1.5rem;
  }
  .embed-container {
      position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    iframe, object, embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0px;
    }
  }
}
